import axios from 'axios';
import config from '../config';

const apiClient = axios.create({
  baseURL: config.server_url,
  timeout: 30000
});

apiClient.interceptors.request.use(
  cfg => {
    const token = localStorage.getItem('feathers-jwt');
    if (token) {
      cfg.headers['Authorization'] = `Bearer ${token}`;
    }

    const method = (cfg.method || 'get').toUpperCase();
    const unsafe = !['GET', 'HEAD', 'OPTIONS'].includes(method);
    if (unsafe && !cfg.headers['X-CSRF-Token']) {
      const match = document.cookie.split('; ').find(row => row.startsWith('XSRF-TOKEN='));
      if (match) {
        cfg.headers['X-CSRF-Token'] = decodeURIComponent(match.split('=')[1]);
      }
    }

    return cfg;
  },
  error => Promise.reject(error)
);

apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('feathers-jwt');
      sessionStorage.removeItem('SELECTED_CMS_VENUE');
      window.location.replace('/');
    }
    return Promise.reject(error);
  }
);

export default apiClient;



// WEBPACK FOOTER //
// ./src/services/apiClient.js